import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ShieldCheck, MessageCircle, ExternalLink, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import TutorBirdWidget from '../components/TutorBirdWidget';
import { TUTORBIRD } from '../config/tutorbird';
import { CONTACT } from '../mock';

export default function Booking() {
  return (
    <div>
      {/* Hero */}
      <section className="hero-bg py-14 md:py-16">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
          <span className="font-semibold uppercase tracking-wider text-xs" style={{ color: '#3d94b8' }}>Termin buchen</span>
          <h1 className="mt-3 text-4xl md:text-5xl font-extrabold tracking-tight" style={{ color: '#1a3a5c' }}>
            Deine erste <span style={{ color: '#3d94b8' }}>kostenlose</span> Beratung
          </h1>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
            Wähle einen freien Termin – unser Team meldet sich zur unverbindlichen Bedarfsanalyse.
          </p>
          {/* Trust badges */}
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            <span className="stat-pill text-sm"><CheckCircle2 className="h-4 w-4" style={{ color: '#25d366' }} /> Kostenlos & unverbindlich</span>
            <span className="stat-pill text-sm"><ShieldCheck className="h-4 w-4" style={{ color: '#3d94b8' }} /> Keine Vertragsbindung</span>
            <span className="stat-pill text-sm"><CheckCircle2 className="h-4 w-4" style={{ color: '#25d366' }} /> Antwort innerhalb 24h</span>
          </div>
        </div>
      </section>

      {/* Booking Widget */}
      <section className="py-8 md:py-12 bg-white">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="card-soft p-4 md:p-6">
            <TutorBirdWidget
              src={TUTORBIRD.widgets.booking}
              fallbackUrl={TUTORBIRD.portalUrl}
              title="TutorBird Buchung"
              minHeight={720}
            />
          </div>

          {/* Alternative contact options */}
          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noreferrer"
              className="card-soft p-6 flex items-center gap-4 group hover:border-green-200"
            >
              <div className="h-14 w-14 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ background: '#e8f7ee' }}>
                <MessageCircle className="h-7 w-7" style={{ color: '#25d366' }} />
              </div>
              <div className="flex-1">
                <div className="text-xs font-semibold uppercase tracking-wider" style={{ color: '#25d366' }}>WhatsApp</div>
                <div className="font-bold mt-0.5" style={{ color: '#1a3a5c' }}>Direkte Antwort in ca. 15 Min</div>
                <div className="text-sm text-slate-500 mt-1">Am schnellsten – einfach chatten</div>
              </div>
              <ExternalLink className="h-4 w-4 text-slate-400 group-hover:text-slate-600" />
            </a>

            <a
              href={`tel:${CONTACT.phoneRaw}`}
              className="card-soft p-6 flex items-center gap-4 group"
            >
              <div className="h-14 w-14 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ background: '#e6f2f7' }}>
                <Phone className="h-7 w-7" style={{ color: '#3d94b8' }} />
              </div>
              <div className="flex-1">
                <div className="text-xs font-semibold uppercase tracking-wider" style={{ color: '#3d94b8' }}>Telefon</div>
                <div className="font-bold mt-0.5" style={{ color: '#1a3a5c' }}>{CONTACT.phone}</div>
                <div className="text-sm text-slate-500 mt-1">Mo–Fr, 9–18 Uhr</div>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Trust section */}
      <section className="py-14 bg-gradient-to-b from-white to-slate-50">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-extrabold" style={{ color: '#1a3a5c' }}>Was passiert nach der Buchung?</h2>
          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            {[
              { n: '1', t: 'Termin bestätigt', d: 'Du erhältst sofort eine Bestätigung per E-Mail.' },
              { n: '2', t: 'Kurzer Vorab-Check', d: 'Wir fragen 2–3 Details zu deinem Bedarf ab.' },
              { n: '3', t: 'Kostenloses Gespräch', d: 'Wir analysieren gemeinsam und schlagen einen Förderplan vor.' },
            ].map((s) => (
              <div key={s.n} className="text-center">
                <div className="h-12 w-12 mx-auto rounded-full text-white font-bold flex items-center justify-center shadow-md" style={{ background: 'linear-gradient(135deg, #4aa5c8, #2d7d9a)' }}>
                  {s.n}
                </div>
                <h3 className="mt-4 font-bold" style={{ color: '#1a3a5c' }}>{s.t}</h3>
                <p className="mt-2 text-sm text-slate-600">{s.d}</p>
              </div>
            ))}
          </div>
          <div className="mt-10">
            <Link to="/faq">
              <Button variant="outline" className="btn-outline-teal rounded-full h-11 px-6">
                Häufige Fragen ansehen
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
